import { useContext, useEffect, useState } from 'react';
import css3 from '../Approvals/css/approval-table.module.css'
import {FiMoreHorizontal as MoreIcon} from 'react-icons/fi';
import {MdOutlineArrowBackIosNew as LBtn,MdOutlineArrowForwardIos as RBtn} from 'react-icons/md';
import { useSelector, useDispatch } from 'react-redux';
import { useSettingModal } from '../../../hooks/Context';
import ViewDetails from './Modal/ViewDetails';
import apiCall from '../../../utils/apiCall';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationContext } from '../../../providers/notification';





const DATA_PER_PAGE = 10;


const InterviewTable = (props:any) =>{
    const [activeData,setActiveData] = useState<any>([]);
    const [pageData,setPageData] = useState<any>([]);
    const [currentPage,setCurrentPage] = useState<number>(0);
    const [pageArr,setPageArr] = useState<any>([]);
    const [showMore,setShowMore] = useState<boolean>(false);
    const [showIndex,setShowIndex] = useState<any>(null);
    const [showSpan,setShowSpan] = useState<boolean>(false);
    const [spanIndex,setSpanIndex] = useState<null | number>(null);
    const {setShowModal,setModalContent} = useSettingModal()
    const data:any = props.data;
    const routeId: number = props.routeId;

    const { showNotification } = useContext(NotificationContext);
    const queryClient = useQueryClient();

    interface PostInterview {
        ApplicantId: string[];
        // RouteId?: number;
        Activity: string;
      }

    const postBatchInvite = async (data: PostInterview): Promise<any> =>{
        return (await apiCall().post('/Activity/BatchInviteTraining', data));
      }
  
      const batchInviteMutation = useMutation(['get-Training-Invite'], postBatchInvite, {retry: 0});
  
      const handleBatchInviteSubmit = async ( applicantId : string) => {
          
            
        const BatchInvitePayloadList = [applicantId]
  
        const BatchInvitePayload = {
          ApplicantId: BatchInvitePayloadList,
          RouteId: routeId,
          Activity: "Interview"
        }
  
        try{
          await batchInviteMutation.mutateAsync(BatchInvitePayload, {
              onSuccess: () => {
                  showNotification({
                      message: 'Invite sent Successfully',
                      type: 'success'
                    });
                    queryClient.invalidateQueries(['get-Interview']);
                   // handleCloseBatchInvite();
                  
              }
          })
      }catch(error: any){
          showNotification({
              message: error?.response?.data?.Message || error.message || error,
              type: 'error'
          });
      } 
      }
  
  
      const handlePrevous = () =>{
        if(currentPage === 0){
            if(pageArr.length > 1){
                setCurrentPage(pageArr.at(-1))
                return false;
            }
            setCurrentPage(0);
            return false;

        }
        setCurrentPage(currentPage-1);
    }

    const handleNext = ()=>{
        if(pageArr.length > 1){
            if(currentPage === pageArr.at(-1)){
                setCurrentPage(0);
                return false;
            }
            setCurrentPage(currentPage+1);
            return false;
        }
        setCurrentPage(0);
    }
  
    const handleMore = (index:number) =>{
        if(index == showIndex){
            setShowIndex(null);
            setShowMore(false);
            return
        }
        setShowIndex(index);
        setShowMore(true);
    }
    const handleSpan = (index:number) =>{
        if(index == spanIndex){
            setSpanIndex(null);
            setShowSpan(false);
            return
        }
        setSpanIndex(index);
        setShowSpan(true);
    }
  
    const handleViewDetails =(data:any)=>{
        setModalContent(<ViewDetails data={data} />);
        setShowModal(true);
    }
  
    // const  handleSendInvite= async (data:any)=>{
    //      await handleBatchInviteSubmit(data.ApplicantId);
    // }
  
  
  
    useEffect(()=>{
        if(data && data.length > 0){
            setActiveData(data);
            let lastPage = Math.ceil(data.length/10);
            let i = 0;
            let arr = [];
            for(i = 0;i<lastPage;i++){
                arr.push(i);
            }
            setPageArr(arr);
            setPageData(data.slice(0,DATA_PER_PAGE));
    
        }
    },[data])
  
    useEffect(()=>{
        if(activeData && activeData.length > 0){    
            let start = currentPage*DATA_PER_PAGE;
            let stop = start+DATA_PER_PAGE;
            setPageData(data.slice(start,stop));  
        }
    },[currentPage])
  
    return (
        <div className={css3.container}>
           
            <>
                <div style={{gridTemplateColumns:`0.8fr 1.2fr 1.2fr 1.1fr`}}>
                    <div>Applicant ID</div>
                    <div>Full Name</div>
                    <div> Email</div>
                    <div>PhoneNumber</div>
                </div>
                <div>
                    {pageData && pageData.length > 0 && pageData.map((eData:any,index:number):any =>
                      <div key={index} style={{gridTemplateColumns:`0.8fr 1.2fr 1.2fr 1.1fr `}}>
                          <div onClick={() => handleSpan(index)}>{eData.ApplicantId.slice(0,12)}...</div>
                          <div onClick={() => handleSpan(index)}>{eData.FullName}</div>
                          
                          <div onClick={() => handleSpan(index)}>{eData.Email}</div>
                          
                          <div>
                          <div onClick={()=>handleSpan(index)}>{eData.PhoneNumber}</div> 
                              
                          <span  className={`${css3.moreSpan} ${index == showIndex?`${css3.activeMore}`:''} `} onClick={()=>handleMore(index)}><MoreIcon />
                              {index == showIndex && showMore ?<div>
                                  <div onClick={() => handleViewDetails(eData)}>View Details</div>
                                  {/* <div onClick={() => handleSendInvite(eData)}>SEND INVITE</div> */}
                              </div> : ''}
                          </span>
                          </div>
                      </div>
                    )}
                </div>
                <div className={css3.pagination}>
                    <div>
                        <button className={`${css3.lBtn} ${css3.btn}`} onClick={handlePrevous} ><LBtn/></button>
                        {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                            if(index <= 2 && currentPage <= 2) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == currentPage ) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == pageArr.length-1) return (
                            <>
                                <>...</>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                            </>
                            )  

                            if(index == 0 ) return (
                            <>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                                <>...</>
                            </>)  

                        })}
                        <button className={`${css3.rBtn} ${css3.btn}`} onClick={handleNext} ><RBtn/></button>
                    </div>
                </div>
            </>
            
        </div>
    )
  }

  export default InterviewTable;